import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import {
  selectCurrentLocation,
  selectCurrentRestaurantGroupId,
} from "@src/store/app_manager/selector";
import { CircularProgress, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { subDays } from "date-fns";
import { SalesHeader } from "./components/SalesHeader";
import { fetchAnalyticsSalesRepo } from "./data/fetchSalesRepository";
import { SalesContainer } from "./components/Body/SalesContainer";
import { NoGraphComponent } from "../OrderGraph/components/NoGraphComponent";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DownloadExcel } from "../../components/DownloadExcel";
import { OverallSales } from "./components/OverallSales";
dayjs.extend(utc);

export const AnalyticsSales: React.FC = () => {
  const weekBeforeDate = subDays(new Date(), 6);

  const onPeriodSelected = (start: Date, end: Date) => {
    setStartPeriod(dayjs(start).utc().toISOString());
    setEndPeriod(dayjs(end).utc().toISOString());
  };

  const selectedLocation = useSelector(selectCurrentLocation);
  const currentGroup = useSelector(selectCurrentRestaurantGroupId);

  const [selectedAggregator, setSelectedAggregator] = useState("wolt");

  const onAggregatorSelect = (aggregator: string) => {
    setSelectedAggregator(aggregator);
  };

  const [startPeriod, setStartPeriod] = React.useState<string>(
    dayjs(weekBeforeDate).utc().toISOString()
  );
  const [endPeriod, setEndPeriod] = React.useState<string>(
    dayjs(Date()).utc().toISOString()
  );

  const { data, status } = useQuery({
    queryKey: [
      "total-amount",
      selectedLocation,
      startPeriod,
      endPeriod,
      selectedAggregator,
    ],
    queryFn: () =>
      fetchAnalyticsSalesRepo.execute({
        startDate: startPeriod,
        endDate: endPeriod,
        restaurantId: selectedLocation === "all" ? "" : selectedLocation,
        groupId: currentGroup,
        aggregator: selectedAggregator,
      }),
    refetchOnWindowFocus: false,
  });

  return (
    <>
      <SalesHeader
        onPeriodSelected={onPeriodSelected}
        onAggregatorSelect={onAggregatorSelect}
      />
      {status === "loading" && (
        <Box alignItems={"center"} display={"flex"} flexDirection={"column"}>
          <CircularProgress />
        </Box>
      )}
      {status === "error" && <Box />}
      {status === "success" &&
        (data.sections && data.sections.length > 0 ? (
          <>
            <Box display={"flex"} flexDirection={"row"}>
              {data.sections.map((section, index) => {
                return (
                  <SalesContainer
                    key={section.title}
                    title={section.title}
                    index={index}
                    value={section.value}
                    diffValue={section.diffValue}
                    periodEnd={endPeriod}
                    periodStart={startPeriod}
                  />
                );
              })}
            </Box>
            <Box
              display="flex"
              sx={{
                paddingTop: 5,
              }}
            >
              <Box
                sx={{
                  paddingRight: 10,
                }}
              >
                <OverallSales
                  title="Продажи, KZT"
                  succeed={data.diffAmount.success}
                  failed={data.diffAmount.cancelled}
                />
              </Box>
              <Box
                sx={{
                  borderLeft: "1px solid #E8E8E9",
                  paddingLeft: 10,
                }}
              >
                <OverallSales
                  title="Количество заказов"
                  succeed={data.diffOrder.success}
                  failed={data.diffOrder.cancelled}
                />
              </Box>
            </Box>

            <DownloadExcel file={data.file} />
          </>
        ) : (
          <NoGraphComponent />
        ))}
      <Box height={"100px"}></Box>
    </>
  );
};
